import { useMemo } from 'react';
import { ResponsiveBar } from '@nivo/bar';
import type { BarDatum, ResponsiveBarSvgProps } from '@nivo/bar';
import { buildNivoTheme } from '../../utils/nivoTheme';

type NivoBarChartProps<D extends BarDatum> = Omit<ResponsiveBarSvgProps<D>, 'theme' | 'animate'> & {
    height?: string;
    xTitle?: string;
    yTitle?: string;
};

function NivoBarChart<D extends BarDatum>({
    height = '100%',
    xTitle,
    yTitle,
    margin,
    axisBottom,
    axisLeft,
    enableGridX = true,
    enableGridY = true,
    groupMode = 'grouped',
    enableLabel = false,
    ...rest
}: NivoBarChartProps<D>) {
    const theme = useMemo(() => buildNivoTheme(), []);

    const resolvedAxisBottom =
        axisBottom === null ? null : { legendPosition: 'middle' as const, legendOffset: 36, ...axisBottom, ...(xTitle ? { legend: xTitle } : {}) };
    const resolvedAxisLeft =
        axisLeft === null ? null : { legendPosition: 'middle' as const, legendOffset: -50, ...axisLeft, ...(yTitle ? { legend: yTitle } : {}) };

    return (
        <div className='chart-container' style={{ height }}>
            <ResponsiveBar
                {...rest}
                theme={theme}
                animate={false}
                enableGridX={enableGridX}
                enableGridY={enableGridY}
                groupMode={groupMode}
                enableLabel={enableLabel}
                margin={margin ?? { top: 20, right: 20, bottom: 50, left: 60 }}
                axisBottom={resolvedAxisBottom}
                axisLeft={resolvedAxisLeft}
            />
        </div>
    );
}

export default NivoBarChart;
